export const aboutRosie = {
	intro: {
		title: null,
    paragraph:
		"Welcome to Rosie's corner of the internet! Rosie is not just any ordinary pup; she's a charismatic canine with a heart of gold and a bundle of energy that never seems to wane. Let us introduce you to the wonderful world of Rosie.",
  },
	name: {
		title: "Name",
		paragraph:
			"Rosie",
	},
  breed: {
    title: "Breed",
    paragraph: "Australian Cattle Dog, Husky, Catahoula Leopard Dog mix",
    graphData: [
      { label: "Australian Cattle Dog", percentage: 25, color: "#ff9500" },
      { label: "Husky", percentage: 25, color: "#007aff" },
      { label: "Catahoula Leopard", percentage: 25, color: "#34c759" },
      { label: "Other", percentage: 25, color: "#8e8e93" },
      { label: "Adorable", percentage: 100, color: "#ff2d55" },
    ]
  },
  coat: {
    title: "Coat",
    paragraph:
      "Rosie boasts a sleek black coat adorned with striking brindle white boots and a chest that catches the eye of all who meet her. With her short hair, she's both stylish and low-maintenance, the perfect combination for an active lifestyle.",
  },
  tricks: {
    title: "Tricks",
    paragraph:
      "Rosie is not your average dog when it comes to intelligence. She has mastered over fourty tricks, showcasing her sharp mind and eagerness to learn. Whether it's playing fetch with her ChuckIt wheel, crawling backwards or forwards, or jumping into your arms, Rosie is always ready to impress with her extensive repertoire of tricks.",
  },
  personality: {
    title: "Personality",
    paragraph:
      "What truly sets Rosie apart is her vibrant personality. She radiates love and affection, making friends wherever she goes. Her playful nature knows no bounds, and she's always up for a game of fetch or a romp in the park. But don't be fooled by her energetic demeanor; Rosie also has a gentle side, and loves a good nap in the sun.",
  },
  mission: {
    title: "Mission",
    paragraph:
      "Rosie's mission is simple: to spread joy and positivity wherever she roams. Whether she's brightening up your Instagram feed with her adorable antics or bringing a smile to your face during a visit to the local dog park, Rosie is here to remind us all of the simple pleasures in life.",
  },
}
